<template>
    <div>
        <el-form ref="form"
                 :model="form"
                 label-width="120px"
                 @submit.prevent.native="onSubmit">
            <el-row :gutter="30">
                <el-col :span="19">
                    <div class="box">
                        <div class="box__header">
                            <span class="box__header--text">{{ getRouteName($route) }}</span>
                            <form-language-switcher></form-language-switcher>
                        </div>
                        <el-form-item label="Maksymalnie zapisów na jeden adres email"
                                      :error="errors['registration_per_email_limit']">
                            <el-input v-model="form['registration_per_email_limit']" type="number"></el-input>
                        </el-form-item>
                        <el-form-item label="Zapisy otwarte">
                            <el-switch v-model="form.registration_open"></el-switch>
                        </el-form-item>
                        <el-form-item label="Nagłowek w wiadomości email">
                            <image-input-component v-model="form.email_header_image"/>
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="box">
                        <div class="box__header">
                            {{ $t('manage') }}
                        </div>
                        <el-form-item class="form__buttons" label-width="0">
                            <el-button @click="onSubmit"
                                       type="primary"
                                       class="fluid form__button"
                                       :loading="loading">
                                {{ $t('submit') }}
                            </el-button>
                        </el-form-item>
                    </div>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>
<script>
    import {SiteSettings} from '@/api/';

    export default {
        data () {
            return {
                loading: false,
                form: {},
                errors: {},
                service: SiteSettings
            }
        },
        mounted () {
            this.fetchData()
        },
        methods: {
            fetchData () {
                this.service.get().then(response => {
                    this.form = response.data
                })
            },
            onSubmit () {
                this.loading = true;
                const service = this.service.update(this.form)
                service
                    .then(this.successHandler)
                    .catch(this.errorHandler)
            }
        }
    }
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// RegistrationSettings.vue?55a2b6b7